import { createSlice } from "@reduxjs/toolkit";
import { fetchSearchResults } from "./GlobalSearchAsynchThunks";
import { initialState, handleFullfilledForFetchSearchResults, handlePendingForFetchSearchResults, handleRejectForFetchSearchResults, handleUpdateSearchTerm, handleUpdateSearchLoading } from "./GlobalSearchReducers";

const globalSearchSlice = createSlice({
    name: "globalSearch",
    initialState,
    reducers: {
        handleUpdateSearchTerm,
        handleUpdateSearchLoading
    },
    extraReducers(builder) {
        builder
            .addCase(fetchSearchResults.pending, handlePendingForFetchSearchResults)
            .addCase(fetchSearchResults.fulfilled, handleFullfilledForFetchSearchResults)
            .addCase(fetchSearchResults.rejected, handleRejectForFetchSearchResults);
    }
});

export const {
    handleUpdateSearchTerm: setSearchTerm,
    handleUpdateSearchLoading: setSearchLoading
} = globalSearchSlice.actions;

export default globalSearchSlice.reducer;
